import React from "react";

export const CircleTickIcon = (props:React.SVGProps<SVGSVGElement> & {size?:number|string}) => (
  <svg {...props} width={props.width || props.size || 30} height={props.height || props.size || 30} viewBox="0 0 50 50" fill={props.fill || "none"} xmlns="http://www.w3.org/2000/svg">
    <path d="M43.75 9.53c-9.53 3.7-17.3 11.86-21.4 22.3a32.03 32.03 0 0 0-7.66-8.9M30.97 12.3a15.63 15.63 0 1 0 5.4 6.86" stroke={props.color ? props.color : "CurrentColor"} strokeWidth={props.strokeWidth || "3"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);